// packages/sim/src/map-data.ts
export const simMapDataConfig = {
  MAP_SPEC_VERSION: 2 as const,
  // Landscape specs require a decoder which understands authoritative terrain.
  LANDSCAPE_MAP_SPEC_VERSION: 3 as const,
  // Pixels per tile. Must match TILE in ./map; used only to bound crossings.
  TILE_PX: 32 as const,
  // Allocation bounds: validation rejects anything larger before allocating.
  // Eight-player highlands needs 320x320: at most 100K tiles / 400 KiB of blockers.
  MAX_MAP_WIDTH: 320,
  MAX_MAP_HEIGHT: 320,
  MAX_MAP_STARTS: 8 as const,
  // Opening supplies plus two expansion sites per seat on eight-player maps.
  MAX_MAP_DOCKS: 32 as const,
  MAX_MAP_CROSSINGS: 16 as const,
  MAX_MAP_NAME_LENGTH: 128 as const,
  // Validate authored allocations before blocker clipping can hide bad spawns.
  MAX_MAP_OBJECTIVES: 128 as const,
  // Per-dock initial stock override (E7): a dock always holds supply.
  MAX_DOCK_SUPPLIES: 200000 as const,
};

// packages/sim/src/map.ts
export const simMapConfig = {
  TILE: 32 as const,
  MAP_W: 64,
  MAP_H: 48,
};

// packages/sim/src/maps.ts
export const simMapsConfig = {
  DEFAULT_MATCH_MAP_ID: "highlands-study" as const,
};

// Validation limits in packages/sim/src/landscape.ts
export const simLandscapeLimits = {
  LandscapeSchema_heights_maximum: 256,
  LandscapeSchema_access_maximum: 2,
  LandscapeSchema_occlusion_maximum: 256,
  LandscapeSchema_props_rotation_maximum: 15,
  LandscapeSchema_props_scale_minimum: 50,
  LandscapeSchema_props_scale_maximum: 150,
  LandscapeSchema_props_maxItems: 4096,
};

export const terrainBuildConfig = {
  // Small irregularities fit under a foundation; ramps and ridges do not.
  maxTileRise: 4,
  maxFoundationRise: 8,
};
